<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>仪器创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/apparatus')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <tz-form
        width="110px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
      ></tz-form>
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addTool } from '@/api/apparatus'

export default {
  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '仪器名称',
          field: 'toolname',
          type: 'text',
          rules: [{ required: true, message: '仪器名称必填', trigger: 'blur' }]
        },
        {
          label: '排序',
          field: 'px',
          type: 'text',
          rules: [{ required: true, message: '排序必填', trigger: 'blur' }]
        }
        // {
        //   label: '仪器代码',
        //   field: 'toolcode',
        //   type: 'text',
        //   rules: [{ required: true, message: '仪器代码必填', trigger: 'blur' }]
        // },
        // {
        //   label: '仪器型号',
        //   field: 'tooltype',
        //   type: 'text',
        //   rules: [{ required: true, message: '仪器型号必填', trigger: 'blur' }]
        // }
      ],
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        },
        {
          content: '重置',
          width: '185px',
          type: ''
        }
      ]
    }
  },
  methods: {
    submitFn(formData) {
      console.log(formData, '仪器创建')
      if (this.submited) return
      this.$loading({
        text: '仪器添加中'
      })
      let dictinfo = JSON.parse(JSON.stringify(formData))
      let addparams = {
        toolname: dictinfo.toolname,
        px: dictinfo.px
      }
      addTool(addparams).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.submited = true
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
      })
      this.$loading().close()
    }
  }
}
</script>

<style></style>
